var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.message)?_c('div',{staticClass:"poster-wrapper",class:{
      small: _vm.small,
      medium: _vm.medium,
      full: _vm.full,
    },on:{"click":function($event){_vm.togglePreview()}}},[(!_vm.previewing)?_c('v-icon',{key:"notPreviewing",staticClass:"tickerpreview-icon grey--text"},[_vm._v("\n      textsms\n    ")]):_vm._e(),_vm._v(" "),(_vm.previewing)?_c('div',{key:"previewing",staticClass:"tickerpreview-icon grey--text"},[_c('ticker-preview',{staticStyle:{"position":"relative","z-index":"2"},style:({
          'max-width': _vm.maxWidth + 'px !important',
        }),attrs:{"message":_vm.message}})],1):_vm._e()],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/components/MiniPreviewTicker.vue?vue&type=template&id=30832600&scoped=true&
// module id = 1799
// module chunks = 5